import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Text, List, ListItem, Link } from '@paygreen/paygreen-ui';
import { dispatchFromKg } from '../../../../utils/co2-calculator';
import { convertToKg } from '../../../../utils/tools';

const CarbonEquivalenceContent = ({ t, carbonValue, unit }) => {
    const { type } = dispatchFromKg(convertToKg(carbonValue, unit));

    const datas = t(`dashboard.equivalence.transports.${type}.source.datas`, {
        returnObjects: true,
    });

    return (
        <>
            <Text textSize="xs" colorWab="grey50" marginTop="sm">
                {t('dashboard.equivalence.modal.ademeText')}

                {/* cannot apply Trans component on <link> and <a> */}
                <a
                    target="_blank"
                    href="https://data.ademe.fr/datasets/base-carbone(r)"
                    rel="noopener noreferrer"
                >
                    <Link
                        colorPallet="status"
                        colorStatus="success"
                        textSize="xs"
                    >
                        {t('dashboard.equivalence.source')}
                    </Link>
                </a>
            </Text>

            <List marginTop="xs" bulletSize="xxs">
                {Array.isArray(datas)
                    ? datas.map((datas, index) => (
                          <ListItem bulletSize="xs" key={index}>
                              <Text textSize="xs" colorWab="grey50">
                                  {datas}
                              </Text>
                          </ListItem>
                      ))
                    : null}
            </List>

            {type === 'plane' && (
                <Text textSize="xs" colorWab="grey50" marginTop="sm">
                    {t('dashboard.equivalence.extraInfo')}
                </Text>
            )}
        </>
    );
};

CarbonEquivalenceContent.propTypes = {
    /**
     * Value in KG
     */
    carbonValue: PropTypes.number,
    /**
     * Unit of carbonValue
     */
    unit: PropTypes.string,
};

export default withTranslation('common')(CarbonEquivalenceContent);
